// Fichier : pages/Admin/SupprimerArticle.js
import React, { useEffect, useState } from 'react';
import api from '../../api';
import './AdminArticles.css';


const SupprimerArticle = () => {
  const [articles, setArticles] = useState([]);
  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    api.get('/articles').then(res => setArticles(res.data));
  }, []);

  const handleDelete = async () => {
    if (!selectedId) return;
    if (!window.confirm('Confirmer la suppression ?')) return;

    try {
      await api.delete(`/articles/${selectedId}`);
      setArticles(prev => prev.filter(a => a._id !== selectedId));
      setSelectedId('');
      alert('Article supprimé');
    } catch (err) {
      alert('Erreur lors de la suppression');
    }
  };

  return (
    <div className="admin-page">
      <h2>Supprimer un article</h2>
      <select onChange={(e) => setSelectedId(e.target.value)} value={selectedId}>
        <option value="">-- Choisir un article --</option>
        {articles.map(a => (
          <option key={a._id} value={a._id}>{a.title}</option>
        ))}
      </select>
      <button onClick={handleDelete} disabled={!selectedId}>Supprimer</button>
    </div>
  );
};

export default SupprimerArticle;
